import { useFormContext } from 'react-hook-form';
import { useCallback } from 'preact/compat';
export default function useVisitors(prefix = '', bands = []) {
    const { watch } = useFormContext();
    const attendees = watch([...Array(9).fill(0).map((_, idx) => `${prefix}Visitors${idx}`)]);
    const calculateVisitors = useCallback(() => {
        const visitors = {};
        attendees.forEach((visitor, idx) => visitors[`Visitors${idx}`] = visitor);
        return visitors;
    }, [attendees]);
    const calculateTotalVisitors = useCallback(() => attendees.reduce((currAttendees, total) => currAttendees + total, 0), [attendees]);
    const getAttendeesString = useCallback(() => bands.reduce((currAttendeesString, band, idx) => {
        if (attendees[idx]) {
            const bandString = `${attendees[idx]} x ${band.Description}`;
            return currAttendeesString === ''
                ? bandString
                : `${currAttendeesString}, ${bandString}`;
        }
        return currAttendeesString;
    }, ''), [attendees]);
    return {
        visitors: calculateVisitors(),
        totalAttendees: calculateTotalVisitors(),
        canProceed: calculateTotalVisitors() > 0,
        attendeeString: getAttendeesString(),
    };
}
